import { useEffect, useState } from 'react'

export const useTouchDevice = (defaultValue: boolean = null) => {
  const [isTouchDevice, setIsTouchDevice] = useState<boolean>(defaultValue)

  useEffect(() => {
    setIsTouchDevice('ontouchstart' in document.documentElement)
  }, [])

  return { isTouchDevice }
}
